import React from 'react';
import './brand-story-banner.css';

const STORY_SLUG = '/blog/why-homebuyers-trust-snageasy';

const BrandStoryBanner = ({ variant = 'default' }) => {
  return (
    <section className={`bsb-section bsb-variant-${variant}`} aria-label="SnagEasy brand story">
      <div className="bsb-container">

        {/* Left: Stats column */}
        <div className="bsb-stats">
          <div className="bsb-stat">
            <span className="bsb-stat-number">50+</span>
            <span className="bsb-stat-label">Homebuyers<br />One Project</span>
          </div>
          <div className="bsb-divider" aria-hidden="true" />
          <div className="bsb-stat">
            <span className="bsb-stat-number">50%</span>
            <span className="bsb-stat-label">Defect Drop<br />In 2 Months</span>
          </div>
          <div className="bsb-divider" aria-hidden="true" />
          <div className="bsb-stat">
            <span className="bsb-stat-number">2 Mo.</span>
            <span className="bsb-stat-label">Project-Wide<br />Impact</span>
          </div>
        </div>

        {/* Right: Story content */}
        <div className="bsb-content">
          <div className="bsb-badge">
            <span className="bsb-badge-dot" aria-hidden="true" />
            Real Story · L&T Rejuve 360, Mulund Mumbai
          </div>
          <h2 className="bsb-heading">
            How 50+ Homebuyers Changed the Quality of an Entire Premium Project
          </h2>
          <p className="bsb-desc">
            Buyers at L&amp;T Rejuve 360 chose SnagEasy independently — word of mouth, no mandates.
            Their inspection reports gave the developer real data. Defects dropped by over 50% project-wide.
            This is what buyer-driven quality looks like.
          </p>
          <a href={STORY_SLUG} className="bsb-cta" aria-label="Read the full brand story">
            Read the Full Story
            <svg className="bsb-arrow" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>

      </div>
    </section>
  );
};

export default BrandStoryBanner;
